import L from 'leaflet';

// Provide backward-compatible aliases for deprecated internal helpers used
// by some plugins. This file is safe to import multiple times; it only
// assigns aliases if they are not already present.
try {
    if (L && L.LineUtil && L.LineUtil.isFlat && !L.LineUtil._flat) {
        L.LineUtil._flat = L.LineUtil.isFlat;
    }
    if (L && L.Polyline && L.LineUtil && L.LineUtil.isFlat && L.Polyline._flat === undefined) {
        L.Polyline._flat = L.LineUtil.isFlat;
    }
} catch (e) {
    // swallow errors during initialization to avoid breaking app startup
    // (e.g., when L is mocked in tests)
}

// Defensive wrapper: ensure DomUtil.getPosition never throws when called
// with a falsy element (Leaflet internals sometimes call it during
// transitions when the DOM element was removed). Return a zero Point
// as fallback.
try {
    if (L && L.DomUtil && typeof L.DomUtil.getPosition === 'function') {
        const _origGetPosition = L.DomUtil.getPosition.bind(L.DomUtil);
        L.DomUtil.getPosition = function (el) {
            if (!el) {
                return new L.Point(0, 0);
            }
            return _origGetPosition(el);
        };
    }
} catch (e) {
    // ignore
}
